import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Notify from "../../../../Notify";
import { UrlApi } from "../../../../../services/apirest";
function AnularEntregaRemito(props) {
const [disBtn, setDisBtn] = useState(false);
  const [notificacion, setNotificacion] = useState({
    open: false,
    mensaje: "",
    severity: "",
    color: "",
  });
  
  const handleClose = () => {
    props.onClose(false);
  };

  const anularEntrega = async () => {
    setDisBtn(true);
    let msj = "Entrega con remito N°"+props.factura.remito_entrega+ " anulada por "+ localStorage.getItem("user")
    try {
      await fetch(`${UrlApi}/envasado_pedidos/${props.factura.id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ estado: 271, remito_entrega: null, obs_anulado:msj}),
      });
    } catch (error) {
      console.error("Error en la solicitud:", error.message);
      alert("Error al anular la entrega: " + error.message);
    } finally {
      handleClose();
    }
  };

  return (
    <div>
      <Dialog open={props.open} onClose={handleClose}>
        {notificacion && notificacion.open ? (
          <Notify
            mensaje={notificacion.mensaje}
            open={notificacion.open}
            color={notificacion.color}
            handleClose={() => {
              props.setOpen(false);
              setNotificacion({ open: false });
            }}
            severity={notificacion.severity}
          />
        ) : null}
        <form>
          <Box backgroundColor={"#1F618D"}>
            <DialogTitle>
              <Typography color="#ffffff" fontSize={20}>
                Anulación de Entrega con Remito: Pedido N°{props.factura.id}
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent>
            <DialogContentText textAlign={"center"}>
              ¿Seguro que quiere anular la entrega con remito?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack spacing={45} direction="row">
              <Button
                color="error"
                disabled={disBtn}
                variant="contained"
                onClick={handleClose}
              >
                Cancelar
              </Button>
              <Button
                color="success"
                type="submit"
                variant="contained"
                disabled={disBtn}
                onClick={anularEntrega}
              >
                Confirmar
              </Button>
            </Stack>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

export default AnularEntregaRemito